<template>
  <div>
    <b-notification v-if="year === 2020" :closable="false">
      <span v-html="$t('compCarbonFormsSurveyCovidInformation.2020-note')" />
    </b-notification>
    <b-notification v-if="year === 2021" :closable="false">
      <span v-html="$t('compCarbonFormsSurveyCovidInformation.2021-note')" />
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'CovidInformation',
  props: {
    year: {
      type: Number,
      default: new Date().getFullYear()
    }
  }
}
</script>
